<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
			sectionclass
		}} u-color-white-900 u-bg-accent-2"
	>
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
			</div>
			<span *ngIf="downloadConfiguration.enableDownload && hasData" class="datatable-icon">
				<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</span>
		</div>
		<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content" [ngClass]="{'no-daily-stats-data-quick-stats': !hasData}">
			<div class="o-stack o-stack--center _u-px-small" *ngIf="quickStatsData && hasData">
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of Ads shown to users"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Impressions</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.impressions; else impressionsblock"
						>{{ quickStatsData.impressions | formatNumber }}</span
					>
					<ng-template #impressionsblock>
						<span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
					</ng-template>
				</div>

				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of times users clicked on Ads"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Clicks</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p">{{ quickStatsData.clicks | formatNumber }}</span>
					<ng-template #clicksblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>

				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Click Through Rate. Number of clicks v number of impressions"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">CTR %</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Click Through Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<ng-template #completionsBlock>
						<div class="u-color-white-900 span_intraction" style="font-size: 0.825em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of calls"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Calls</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p">{{ quickStatsData.calls }}</span>
					<ng-template #visitsblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<!-- <div class="o-stack__cell content_mainCls" appTooltip title="% of your ad impressions that are shown as the very first ad above the organic search results"
                *ngIf="(range === 'WITHIN' || range === 'AFTER')"
                    data-size="big" [options]="tooltipOptions">
                    <h5 class="u-color-white-900">Absolute Top Impression</h5><span class="u-font-medium u-lh-normal u-opacity-80p">{{quickStatsData.absTopImpression}}%</span>
                    <ng-template #viewthroughblock>
                        <div class="u-color-white-900 span_intraction" style="font-size:1.2em"> --</div>
                    </ng-template>
                </div> -->
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Average Position reporting is being removed 30 Sept 2019."
					*ngIf="range === 'AFTER' || range === 'WITHIN'"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Avg. Position</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p">{{
						quickStatsData.avgPosition ? (quickStatsData.avgPosition | number : '0.2-2') : '--'
					}}</span>
					<ng-template #viewthroughblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div
				class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
					sectionclass
				}} u-color-white-900 u-bg-accent-2"
			>
				<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
					<div class="o-stack__cell">
						<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
					</div>
				</div>
				<div class="map-no-data" style="text-align: center; color: #fff">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
